import { ComparisonTools } from "@/components/comparison/ComparisonTools";
import { profileComparable } from "./profile-comparable";
export function ProfileComparisonTools({ personId, name, viewerId, avatarContent, avatarMime }: { personId: string; name: string; viewerId: string; avatarContent?: string | null; avatarMime?: string | null }) {
  return <ComparisonTools comparable={profileComparable} viewerId={viewerId} current={{ id: personId, name, avatarContent, avatarMime }} />;
}
